import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {IHttpService} from "angular";
import {VolatilityMovers} from "../models/VolatilityMovers";
import {VolatilityChange} from "../models/VolatilityChange";

export class VolatilityMoversService extends BehaviorSubject<VolatilityMovers> {

    public static id = "volatilityMoversService";

    /** @ngInject */
    public constructor(private $http: IHttpService) {
        super(new VolatilityMovers([]));
        this.init();
    }

    private init() {
        this.loadData();
    }

    private async loadData() {
        const moversResponse = await this.$http.get<Array<string>>("/tradefloor/api/watchlist/movers/vol");
        const movers = moversResponse.data!;

        const volsResponse = await this.$http.post<Array<VolatilityChange>>("/tradefloor/api/watchlist/vols", movers);
        const volChanges = volsResponse.data!;

        this.next(new VolatilityMovers(volChanges));
    }

    public refresh() {
        this.loadData();
    }

    public current(): VolatilityMovers {
        return this.value;
    }
}
